<template>
  <v-card max-width="500px">
    <v-card-title class="pb-2 text-center">
      <v-row>
        <v-col cols="12" class="py-0">
          <LendaIcon :src="logo" />
        </v-col>
        <v-col cols="12" class="py-0">
          <div v-html-safe="modalData.title"></div>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="px-6">
          <div v-html-safe="modalData.description"></div>
    </v-card-text>
    <v-divider></v-divider>
    <v-flex tag="v-card-actions" px-6 py-4>
        <fp-btn v-if="modalData.falseText" outlined depressed @click="() => closeModal(false)">{{ modalData.falseText }}</fp-btn>
        <v-spacer></v-spacer>
        <fp-btn primary outlined depressed @click="() => closeModal(true)">{{ modalData.trueText }}</fp-btn>
    </v-flex>
  </v-card>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { TourModalType } from '@/modules/onboarding/tour/models/TourOptions';
import LendaIcon from '@/components/commons/LendaIcon.vue';

const props = defineProps<{
  modalData: Record<string, any>;
  showDialog?: boolean;
}>();

const emit = defineEmits(['closeModal']);

const logo = computed(() => {
  const logoName: string = props.modalData.modalType === TourModalType.FINISH
    ? 'finish' : 'default';
  return require(`../../assets/onboarding/onboarding_${logoName}_logo.svg`);
});

const closeModal = (data?: boolean) => {
  emit('closeModal', data);
};
</script>

